/************
 * Model Class
 * File Name ...: document-category.ts
 * Generated By : vishnu on 01/20/24
 * Date ........: 01/20/24
 /************/
import {ValidationResult} from './validation-result';

export interface DocumentCategory {
    id: number | null;
    description: string | null;
    activeStatus: string | null;
}

export class DocumentCategory {
    constructor() {
        this.id = 0;
        this.description = '';
        this.activeStatus = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.description.length === 0) {
            vr.focus_field = 'description';                              /* this should be the id value of the field */
            vr.error = 'Error: a description / value is required';
            return vr;
        }

        return vr;
    }
}
